import React, { memo } from 'react'
import styles from "./DeleteModal.module.scss"
import Button from 'components/shared/button/Button';
import TaskDeleteIcon from "assets/svg/TaskDeleteIcon.svg"
import { privateDelete } from 'services/privateRequest';
import toast from 'react-hot-toast';


const DeleteModal = ({
    modalOpen,
    setModalOpen,
    getData,
    selected,
    setSelected,
    endPoint,
    doNotClose = false,
    heading="",
}) => {

    const handleDelete = async () => {
        try {
            const res = await privateDelete(endPoint, selected?._id);
            if (res) {
                getData();
                setSelected({});
                setModalOpen(false);
                toast.success(`${heading} deleted successfully`);

            }
        } catch (error) {
            console.error(`Error deleting ${heading}:`, error);
        }
        
    }

    if (modalOpen) {
        return (
            <div className={styles.mainContainer} onMouseDown={(e) => {
                e.stopPropagation()
                !doNotClose && setModalOpen(false)
            }}>
                <div className={styles.modalDiv} onMouseDown={(e) => e.stopPropagation()}>
                    <div className={styles.modalHeader}>
                        <p>Delete {heading}</p>
                    </div>
                    <hr className={styles.horizontalLine} />
                    <div className={styles.iconAndContent}>
                        <div className={styles.iconContainer}>
                            {<img className={styles.iconStyle} src={TaskDeleteIcon} />}
                        </div>
                        <div className={styles.modalBody}>
                            <p>Are you sure, Do you want to Delete this {heading} ?</p>
                        </div>
                    </div>
                    <hr className={styles.horizontalLine} />
                    <div className={styles.twoButton}>
                        <Button className={styles.whiteButton} onClick={() => setModalOpen(false)}>Cancel</Button>
                        <Button
                            className={styles.blueButton}
                            onClick={handleDelete}
                        >
                            Delete
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default memo(DeleteModal);